<template>
    <div>
        <div v-if="this.categoryId < 1">
            invalid category id.
        </div>
        <div v-else>
            <front-product-item :product-id="product.id" :brief-product="product" v-for="(product, index) in products"
                :key="index"></front-product-item>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        props: {
            categoryId: {
                default: 0
            }
        },
        data() {
            return {
                products: []
            }
        },
        mounted() {
            this.initProducts();
        },
        methods: {
            initProducts() {
                axios.get(`${base_url}/api/category/${this.categoryId}/products`)
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        this.products = response_data.products;
                    })
                    .catch((...response_error) => { });
            }
        }
    }
</script>